// extracted by mini-css-extract-plugin
export default {"wrapper":"PixelForm_wrapper__mdTIl","container":"PixelForm_container__dLopC","title":"PixelForm_title__m+MH3","buttonsContainer":"PixelForm_buttonsContainer__mGf6W"};